/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import {
  Component,
  Input,
  OnChanges,
  ChangeDetectionStrategy,
  SimpleChanges
} from '@angular/core';
import { ChartData } from '../../../charts/models/ChartData';

@Component({
  selector: 'app-ctv-ad-spend',
  templateUrl: './ctv-ad-spend.component.html',
  styleUrls: ['./ctv-ad-spend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CtvAdSpendComponent implements OnChanges {
  @Input() data: any;
  @Input() isFreemium: boolean;
  lineChartData: Array<ChartData>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data']) {
      if (this?.data?.adSpend?.byMonth) {
        this.lineChartData = this?.data?.adSpend?.byMonth;
        this.lineChartData.reverse();
      }
    }
  }
}
